import React from 'react';
import PropTypes from 'prop-types';
import './Divider.css';

interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  dashed?: boolean;
  orientation?: 'left' | 'right' | 'center';
}

class Divider extends React.Component<DividerProps> {
  static propTypes = {
    dashed: PropTypes.bool,
    orientation: PropTypes.oneOf(['left', 'right', 'center']),
  }

  static defaultProps = {
    dashed: false,
    orientation: 'center',
  }

  render() {
    const { dashed, orientation, children, ...rest } = this.props;
    let className = 'divider';
    
    if (dashed) {
      className += ' divider--dashed';
    }

    className += ` divider--${orientation}`;

    return (
      <div className={className} {...rest}>
        {children}
      </div>
    );
  }
}

export default Divider;
